import type { Customer } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'
import { isValidEmail, isValidPhoneNumber } from '@ztechapps/common.utils'
import set from 'lodash/set'

export const UserFormValidate = (value: Customer) => {
  const errors: any = {}

  //validate the phone number
  if (!isEmpty(value?.phone)) {
    if (!isValidPhoneNumber(value?.phone)) {
      errors.phone = 'Invalid phone number'
    }
  }

  //validate the email address
  if (!isEmpty(value?.profile?.email)) {
    if (!isValidEmail(value?.profile?.email)) {
      set(errors, 'profile.email', 'Invalid email address')
    }
  } else {
    //email is required
    set(errors, 'profile.email', 'Email is required')
  }

  //company is required
  if (!value?.company?.name) {
    set(errors, 'company', 'Company is required')
  }

  return errors
}
